import { useState } from 'react'
import './ListNotifiCation.scss'

export default function ListNotifiCation() {
  const [tabNotification, setTabNotification] = useState('1')
  
  return (
    <>
      <div className="cfzljvswiw">
        <div className="shwzfueito">
          <div onClick={() => setTabNotification('1')} className={`ynotigxbdq ${tabNotification === '1' ? 'voryedbpzm' : ''}`}>Thông báo chung</div>
          <div onClick={() => setTabNotification('2')} className={`ynotigxbdq ${tabNotification === '2' ? 'voryedbpzm' : ''}`}>Sự kiện</div>
          <div onClick={() => setTabNotification('3')} className={`ynotigxbdq ${tabNotification === '3' ? 'voryedbpzm' : ''}`}>Tín hiệu kỹ thuật</div>
        </div>
        <div className="venbapczdb">
          {
            [0, 1, 2, 3, 4, 5, 6].map((item) => {
              return (
                <div className="nuisoymlgy" key={item}>
                  <div className="crscercmao"><img className="jwvivnjfdu" alt="" src="" /></div>
                  <div className="txjmknyypz">
                    <div className="sowprmiirq">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    <div className="aowcowkbmt">(03/08/2022 16:45)</div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  )
}